import { useMemo, FC, Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';
import { Table, EditableCell } from '../../../components';
import { IACHVendorEmail, IResponse } from '../../../models';
import { getVendorEmails } from '../../../fetch';
import { isEmail } from '../../../helpers';

interface IVendorEmailsTable {
  batchNumber: number | string;
  setVendorEmails: Dispatch<SetStateAction<IACHVendorEmail[]>>;
  vendorEmails: IACHVendorEmail[];
}

export const VendorEmailsTable: FC<IVendorEmailsTable> = ({ batchNumber, vendorEmails, setVendorEmails }) => {
  const { isLoading: isLoadingVendorEmails } = useQuery<IResponse<IACHVendorEmail[]>, Error>(['vendorEmails', batchNumber], () => getVendorEmails(batchNumber), {
    enabled: !!batchNumber,
    notifyOnChangeProps: 'tracked',
    onSuccess: data => {
      setVendorEmails(data?.records ?? []);
    },
    cacheTime: 0,
    staleTime: Infinity
  });
  const columns = useMemo(() => {
    return [
      {
        Header: 'Vendor',
        accessor: 'vendor',
        sort: false
      },
      {
        Header: 'Email',
        accessor: 'vendorAchEmail',
        sort: false,
        Cell: props => {
          return (
            <EditableCell
              {...props}
              hasError={!isEmail(props?.cell?.row?.original?.vendorAchEmail)}
              helperText={!isEmail(props?.cell?.row?.original?.vendorAchEmail) ? 'Invalid Email' : ''}
            />
          );
        }
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorEmails]);

  const updateMyData = (vendorEmail: IACHVendorEmail, columnId: string, value: string, rowIndex: number) => {
    setVendorEmails((old: IACHVendorEmail[]) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...vendorEmail,
            [columnId]: value
          };
        }
        return row;
      })
    );
  };

  return (
    <Table
      columns={columns}
      data={vendorEmails}
      isLoading={isLoadingVendorEmails}
      hidePagination
      useTableProps={{
        updateMyData
      }}
    />
  );
};
